export default {
  form_title: "استمارة التسجيل والموافقة لتلقي أخبارنا",
  basf_intro: "مرحباً وشكراً لاهتمامك بشركة BASF  للحلول الزراعية.",
  i_have_read: "لقد قرأت وأوافق على",
  data_protection_policy: "سياسة حماية البيانات الشخصية",
  i_understand: "الخاصة بشركة BASF SPA. أفهم أنه يمكنني طلب تحديث أو تصحيح أو حذف أو قفل بياناتي الشخصية في أي وقت وفقًا للقانون رقم 18-07 المتعلق بحماية البيانات الشخصية.",
  form_description: "مرحباً وشكراً لاهتمامك بشركة BASF للحلول الزراعية. لتلقي أخبارنا، والنصائح الزراعية، وتنبيهات الأمراض، ومعلومات عن المنتجات، ودعوات لفعالياتنا، يرجى ملء النموذج أدناه.",

  placeholders: {
    last_name: "الاسم*",
    first_name: "اللقب*",
    phone: "رقم الهاتف المحمول*",
    function: "اختر وظيفتك*",
    company: "اسم الشركة أو نقطة البيع",
    hectares: "عدد الهكتارات",
    wilaya: "اختر ولايتك*",
    search: "...ابحث",

    commune: "اختر بلديتك*",
    noResultsFound: " لم يتم العثور على نتائج"
  },

  labels: {
    cultures: "اختر المحاصيل التي تهمك:*",
    hectares_note: "(إذا كنت فلاحاً)"
  },

  function: {
    agriculteur: "فلاح",
    revendeur: "تاجر",
    distributeur: "موزع",
    inspecteur: "مفتش الصحة النباتية",
    consultant: "مستشار زراعي",
    autre: "أخرى"
  },

  submit: "تأكيد",

  errors: {
    last_name: "• الاسم إجباري",
    first_name: "• اللقب إجباري",
    phone: "• رقم الهاتف غير صالح",
    phone_invalid: "• رقم الهاتف غير صالح",
    phone_exists: "•  هذا الرقم مسجل لدينا",
    company: "• اسم الشركة أو نقطة البيع إجباري",
    wilaya: "• الولاية إجبارية",
    commune: "• البلدية إجبارية",
    cultures: "• يرجى اختيار محصول واحد على الأقل",
    function: "• الوظيفة إجبارية",
    rules: "• للمواصلة، يرجى الموافقة على سياسة حماية البيانات الشخصية"
  },

  alerts: {
    otp_error: "تعذر إرسال رمز التحقق. يرجى المحاولة مرة أخرى.",
    generic_error: "حدث خطأ"
  },

  cultures: {
    pomme_de_terre: "البطاطا",
    cereales: "الحبوب",
    tomate_industrielle: "الطماطم الصناعية",
    tomate_plein_champ: "الطماطم الحقلية",
    tomate_sous_serre: "الطماطم المغطاة",
    arbres_fruitiers: "أشجار الفواكه",
    melon_pasteque: "البطيخ والدلاع",
    autres_cucurbitacees: "القرعيات الأخرى",
    mais: "الذرة (علف، حبوب)",
    oleagineuses: "المحاصيل الزيتية",
    agrumes: "الحمضيات",
    vigne: "العنب",
    legumineuses: "البقوليات (عدس، حمص، فول)"
  },

  phoneConfirmation: {
    successTitle: "تم التسجيل بنجاح",
    successMessage: "شكراً! تم تأكيد تسجيلك بنجاح",
    go_to_profile: "عرض بياناتي",
    okButton: "حسناً",
    confirmTitle: "تأكيد التسجيل",
    confirmDescription: "لإتمام التسجيل، يرجى إدخال الرمز المكون من 5 أرقام الذي وصلك عبر الرسائل القصيرة.",
    errorMessage: "الرمز الذي أدخلته غير صحيح. يرجى المحاولة مرة أخرى.",
    resentMessage: "تم إعادة إرسال الرمز.",
    resendCode: "إعادة إرسال الرمز",
    resendIn: "إعادة الإرسال خلال {seconds}ث",
    confirmButton: "تأكيد"
  },

  login: {
    title: "تسجيل الدخول",
    subtitle: "سجّل دخولك باستخدام رقم هاتفك",
    phoneLabel: "رقم الهاتف",
    sendCode: "إرسال الرمز",
    noAccount: "إذا لم يكن لديك حساب،",
    signUp: "سجّل الآن",
    otpSent: "تم إرسال الرمز إلى رقمك.",
    codeError: "الرمز غير صحيح.",
    resendCode: "إعادة إرسال الرمز",
    resendIn: "إعادة الإرسال خلال {seconds}ث",
    confirm: "تأكيد",
    sendingCode: "جاري إرسال الرمز إلى الرقم:",
    cancel: "إلغاء",
    phoneRequired: "رقم الهاتف مطلوب.",
    phoneInvalid: "يجب أن يبدأ الرقم بـ 0 ويتكون من 10 أرقام.",
    phoneInvalidGeneric: "هذا الرقم غير مسجل",
  },



  admin_edit: {

    title: "تعديل البيانات ",
    change_email: "تغيير البريد الإلكتروني",
    email: "البريد الإلكتروني",
    change_phone: "تغيير رقم الهاتف",
    phone: "رقم الهاتف",
    change_password: "تغيير كلمة المرور",
    currentPassword: "كلمة المرور الحالية",
    newPassword: "كلمة المرور الجديدة",
    confirmNewPassword: "تأكيد كلمة المرور الجديدة",
    submit: "تأكيد",
    validate: "تأكيد",
    cancel: "إلغاء",
    menu_item: "تعديل البيانات",
    modal_password_title: "تأكيد التغييرات",
    modal_password_sub: "يرجى إدخال كلمة المرور الخاصة بك لتأكيد التغييرات التي أُجريت على حسابك.",


    errors: {
      phoneInvalid: "• رقم الهاتف غير صالح",
      alreadyExistPhone: "• رقم الهاتف موجود بالفعل",
      invalidPassword: "• كلمة المرور غير صحيحة",
      alreadyExistEmail: "• البريد الإلكتروني مستخدم بالفعل",
      emailRequired: "• البريد الإلكتروني إجباري",
      weakPassword: "• يجب أن تحتوي كلمة المرور الجديدة على 8 أحرف على الأقل",
      passwordMismatch: "• كلمتا المرور غير متطابقتين"
    }
  },

  edit: {
    intro: "تظهر معلوماتك الحالية في النموذج أدناه. يمكنك تعديلها ثم النقر على زر التأكيد.",
    last_name: "الاسم*",
    first_name: "اللقب*",
    phone: "رقم الهاتف المحمول*",
    function: "اختر وظيفتك*",
    company: "اسم الشركة أو المزرعة",
    hectares: "عدد الهكتارات",
    if_farmer: "(إذا كنت فلاحاً)",
    cultures_label: "اختر المحاصيل التي تهمك:*",
    select_wilaya: "اختر ولايتك*",
    select_commune: "اختر بلديتك*",
    confirm: "تأكيد",
    done_editing: "هل انتهيت من تعديل معلوماتك؟",
    logout: "تسجيل الخروج",
    errors: {
      last_name: "• الاسم إجباري",
      first_name: "• اللقب إجباري",
      phone: "• رقم الهاتف غير صالح",
      function: "• الوظيفة إجبارية",
      wilaya: "• الولاية إجبارية",
      commune: "• البلدية إجبارية",
      cultures: "• يرجى اختيار محصول واحد على الأقل"
    }
  },

  edit_otp: {
    title: "تأكيد التسجيل",
    description: "لإتمام التعديل، يرجى إدخال الرمز المكون من 5 أرقام الذي وصلك عبر الرسائل القصيرة.",
    error: "الرمز الذي أدخلته غير صحيح. يرجى المحاولة مرة أخرى.",
    resent: "تم إعادة إرسال الرمز.",
    resend: "إعادة إرسال الرمز",

    resend_in: "إعادة الإرسال خلال {seconds}ث",
    confirm: "تأكيد",
    cancel: "إلغاء"
  },

  admin_dashboard: {
    stats: {
      total_submissions: "إجمالي الطلبات",
      top_culture: "أكثر المحاصيل",
      avg_hectares: "متوسط المساحة",
      top_function: "أكثر الوظائف",

    },
    export: "تحميل ملف إكسل",
    table: {
      last_name: "الاسم",
      first_name: "اللقب",
      phone: "الهاتف",
      function: "الوظيفة",
      company: "الشركة",
      hectares: "الهكتارات",
      wilaya: "الولاية",
      commune: "البلدية",
      cultures: "المحاصيل",
      date: "تاريخ التسجيل"
    },
    pagination: {
      previous: "السابق",
      next: "التالي"
    },
    title: "الصفحة الرئيسية"

  },

  admin: {
    title: "تسجيل الدخول",
    subtitle: "سجّل دخولك باستخدام بريدك الإلكتروني وكلمة المرور",
    email: "البريد الإلكتروني",
    password: "كلمة المرور",
    submit: "تسجيل الدخول",
    errors: {
      email_required: "البريد الإلكتروني إجباري.",
      password_required: "كلمة المرور إجبارية.",
      password_invalid: "كلمة المرور غير صحيحة.",
      invalid_credentials: "بيانات الدخول غير صحيحة."
    },
    logout: "تسجيل الخروج",
    forgot_password: "هل نسيت كلمة المرور؟",
    recover_password: " اضغط هنا لاستعادتها"
  },

  recover_password: {
    title: "نسيت كلمة المرور",
    subtitle: "استعد حسابك باستخدام رقم هاتفك",
    phoneLabel: "رقم الهاتف",
    sendCode: "إرسال رمز الاستعادة",
    noAccount: "ليس لديك حساب؟",
    signUp: "سجّل الآن",
    otpSent: "تم إرسال رمز الاستعادة إلى رقمك.",
    codeError: "رمز التحقق غير صحيح.",
    resendCode: "إعادة إرسال الرمز",
    resendIn: "إعادة الإرسال خلال {seconds}ث",
    confirm: "تأكيد الرمز",
    sendingCode: "جاري إرسال رمز الاستعادة إلى الرقم:",
    cancel: "إلغاء",
    phoneRequired: "رقم الهاتف مطلوب لإعادة تعيين كلمة المرور.",
    phoneInvalid: "يجب أن يبدأ الرقم بـ 0 ويتكون من 10 أرقام.",
    phoneInvalidGeneric: "رقم الهاتف غير صالح.",
    resetPassword: "أدخل كلمة المرور الجديدة",
    newPassword: "كلمة المرور الجديدة",
    confirmPassword: "تأكيد كلمة المرور",
    submitNewPasword: "تأكيد",
    successMessage: "تم تعديل كلمة المرور بنجاح.",
    successTitle: "تمت إعادة تعيين كلمة المرور بنجاح",
  },


  admin_create: {
    admin_list: "لائحة الإداريين",
    title: "إنشاء مدير",
    subtitle: "املأ المعلومات اللازمة لإنشاء مدير جديد",
    email: "البريد الإلكتروني",
    phone: "رقم الهاتف",
    password: "كلمة المرور",
    confirm_password: "تأكيد كلمة المرور",
    submit: "حفظ",
    cancel: "إلغاء",
    errors: {
      email_required: "البريد مطلوب",
      email_invalid: "البريد غير صحيح",
      email_exists: "البريد موجود",
      password_required: "كلمة المرور مطلوبة",
      password_short: "كلمة المرور قصيرة",
      phone_required: "الهاتف مطلوب",
      phone_invalid: "الهاتف غير صحيح",
      phone_exists: "هذا الرقم مسجل لدينا",
      password_mismatch: "• كلمتا المرور غير متطابقتين"


    }
  },

  deleteInfo: "حذف بياناتي الشخصية",
  successTitle: "تعديل بياناتك الشخصية",
  successMessage: "تم تعديل بياناتك الشخصية بنجاح.",
  deleteErrorTitle: "حذف بياناتك الشخصية",
  deleteErrorMessage: "حدث خطأ: لم يتم حذف بياناتك الشخصية.",
  deleteSuccessTitle: "حذف بياناتك الشخصية",
  deleteSuccessMessage: "تم حذف بياناتك الشخصية بنجاح.",
  deleteConfirmTitle: "حذف بياناتك الشخصية",
  deleteConfirmMessage: "هل تؤكد أنك تريد حذف بياناتك الشخصية وعدم تلقي أي تواصل من شركة BASF SPA؟",
  deleteConfirmCancel: "إلغاء",
  deleteConfirmDelete: "حذف",
  already_have_account: "يرجى ملء جميع الحقول الإجبارية *",
  loginMsg: "تعديل أو حذف بياناتي",

}

